exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1eiwVlAQZJuox6j15gE8pe{display:inline-block;vertical-align:middle;text-align:center;font-size:0;line-height:0}._1eiwVlAQZJuox6j15gE8pe svg{height:100%;width:auto;fill:currentColor;stroke:currentColor}._3YNh1noPqzIA4cSfsklDEv svg{vertical-align:middle}\n", ""]);

// Exports
exports.locals = {
	"Icon": "_1eiwVlAQZJuox6j15gE8pe",
	"alignMiddle": "_3YNh1noPqzIA4cSfsklDEv"
};